import type { CSSProperties } from "react";

type Expression = "main" | "welcome" | "happy";

/** Approved 2B silhouette. The alpha mask keeps every expression in the theme color. */
export function BrandMark({
  expression = "main",
  size = 40,
  className = "",
}: {
  expression?: Expression;
  size?: number;
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      className={`brand-mark ${className}`}
      style={
        {
          width: size,
          height: size,
          "--brand-image": `url(/brand/gaemitalk-${expression}.png)`,
        } as CSSProperties
      }
    />
  );
}

/** A positive settled result is the game's success state; void rounds never celebrate. */
export function ResultMascot({
  profit,
  invalid,
}: {
  profit: number;
  invalid?: boolean;
}) {
  return profit > 0 && !invalid ? (
    <BrandMark expression="happy" size={64} className="result-mascot" />
  ) : null;
}
